// 📂 src/context/AuthContext.tsx
import React, { createContext, useContext } from "react";
import useAuth from "../hooks/useAuth";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();

  return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);
